import request from '@/utils/request'

export function menuApi(){
    return request({
        url: '/coffee/menu/nav',
        method: 'get',
        params:{}
      })
}
export function menuListApi(){
  return request({
      url: '/coffee/menu',
      method: 'get',
      params:{}
    })
}
export function menuSelectApi(){
  return request({
      url: '/coffee/menu/select',
      method: 'get',
      params:{}
    })
}
export function menuSaveApi(param){
  return request({
    url: '/coffee/menu',
      method: 'post',
      data:param
    })
}
export function menuInfoApi(id){
  return request({
    url: `/coffee/sys/menu/info/${id}`,
      method: 'get',
      params:null
    })
}
/**
 * 
 * @returns 菜单删除
 */
 export function menuDeleteApi(param){
  return request({
      url: '/coffee/menu',
      method: 'DELETE',
      data:param
    })
}
/**
 * 
 * @returns 菜单更新
 */
export function menuUpdateApi(param){
  return request({
      url: '/coffee/menu',
      method: 'put',
      data:param
    })
}

export function roleListApi(param){
  return request({
      url: '/coffee/role/list',
      method: 'post',
      data:param
    })
}
export function roleSaveApi(param){
  return request({
    url: `/coffee/role`,
      method: 'post',
      data:param
    })
}
export function roleUpdataApi(param){
  return request({
    url: `/coffee/role`,
      method: 'put',
      data:param
    })
}
export function roleSelectApi(param){
  return request({
      url: '/coffee/role/list',
      method: 'post',
      data:param
    })
}
export function roleDeleteApi(params){
  return request({
      url: '/coffee/role',
      method: 'delete',
      data:params
    })
}

export function userMenuListApi(){
  return request({
      url: '/coffee/menu/select',
      method: 'get',
      params:{}
    })
}
export function permissionApi(){
  return request({
      url: '/coffee/user/permission',
      method: 'get',
      params:{}
    })
}





// WEBPACK FOOTER //
// ./src/api/sys.js